import { BaseModal } from "../../components/modalCommon/modalBase";
import { ModalHeader } from "../../components/modalCommon/modalHeader";
import { ModalBody } from "../../components/modalCommon/modalBody";
import { ModalFooter } from "../../components/modalCommon/modalFooter";
import { useI18n } from "../../utils/translate/i18n/useI18n";

import FormActionButton from "../../components/formActionButton/formActionButton";
import "./infoModal.scss";
import type { InfoModalModel } from "../../type/modal";

export default function InfoModal({ open, onClose }: InfoModalModel) {
  const { t } = useI18n();

  return (
    <BaseModal open={open} onClose={onClose} size="md">
      <ModalHeader title={t("UWAGA!")} onClose={onClose} />
      <ModalBody>
        <p className="mb-3">
          {t("Badanie ma charakter wyłącznie informacyjny. Nie stanowi podstawy do diagnozy ani leczenia medycznego. W celu potwierdzenia wyników zalecamy umówienie się na profesjonalne badanie słuchu w naszym gabinecie, które jest wykonywane na certyfikowanym sprzęcie medycznym, co zapewnia wysoką precyzję i wiarygodność wyników.")}
        </p>


      </ModalBody>
      <ModalFooter>
        <FormActionButton
          type="button"
          variant="primary"
          fullWidth
          iconClassName="bi bi-arrow-right-circle"
          onClick={onClose}
        >
          {t("Rozumiem, przejdź do testu")}
        </FormActionButton>
      </ModalFooter>
    </BaseModal>
  );
}
